import './style.scss';
import { ResultBody, ResultHeader } from 'views/mutual/result';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { ContractDetailInfo } from 'views/utils/graphql/graphql';
import { DateFormatType, formatDate, formatPrice } from 'views/utils/converter';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { CheckLabel, CheckLabelTextSize } from 'views/mutual/checkLabel';
import PDFViewer from 'views/mutual/pdfViewer';
import { useOverseasRealEstateSymbolPage } from 'views/pages/symbol/overseasRealEstate/hooks';
import { useDomesticRealEstateItExplanationSymbolPage } from 'views/pages/symbol/domesticRealEstate/itExplanation/hooks';
import { Caption } from 'views/mutual/caption';
import { useEffect, useState } from 'react';
import { getPdfData } from 'views/utils/download';
import { LoadingContainer } from 'views/mutual/loading';

type OverseasRealEstateContractConfirmProps = {
  contractInfo: ContractDetailInfo;
  setCheckedAssignmentAgreementDocument: (value: boolean) => void;
  setCheckedContractAgreementDocument: (value: boolean) => void;
  setOpenedContractAgreementDocument: (value: boolean) => void;
  checkedAssignmentAgreementDocument: boolean;
  checkedContractAgreementDocument: boolean;
  openedContractAgreementDocument: boolean;
  onNext: () => void;
  onBack: () => void;
};
export const OverseasRealEstateContractConfirm = ({
  contractInfo,
  setCheckedAssignmentAgreementDocument,
  setCheckedContractAgreementDocument,
  setOpenedContractAgreementDocument,
  checkedAssignmentAgreementDocument,
  checkedContractAgreementDocument,
  openedContractAgreementDocument,
  onNext,
  onBack,
}: OverseasRealEstateContractConfirmProps) => {
  useCustomLocationName('契約申込内容確認');
  const { symbolDetailInfo } = useOverseasRealEstateSymbolPage({ symbol: contractInfo.Symbol });

  const [pdfData, setPDFData] = useState<string>();
  useEffect(() => {
    getPdfData({
      PdfId: contractInfo?.AssignmentAgreementDocumentInfo?.ID ?? '',
    }).then((data) => {
      setPDFData(data);
    });
  }, [contractInfo]);

  return (
    <LoadingContainer isLoading={!pdfData}>
      <div className="overseasRealEstateContractConfirm">
        <Caption label="お申込内容" />
        <div className="overseasRealEstateContractConfirm_wrapper">
          <OverseasRealEstateContractConfirmBody contractInfo={contractInfo} />
        </div>
        <div className="overseasRealEstateContractConfirm_container">
          <PDFViewer file={pdfData} isBottom={() => setCheckedAssignmentAgreementDocument(true)} />
        </div>
        <div className="overseasRealEstateContractConfirm">
          <CheckLabel
            checked={checkedContractAgreementDocument}
            onChange={() => setCheckedContractAgreementDocument(!checkedContractAgreementDocument)}
            before="本事業の"
            link="「海外不動産事業投資案件の契約締結前交付書面」"
            href={symbolDetailInfo.data?.GetOverseasRealEstateSymbolInfo?.PreContractDocumentURL}
            after="をダウンロードし、記載内容をよく読んで確認しました"
            linkClicked={openedContractAgreementDocument}
            onClick={async () => {
              setOpenedContractAgreementDocument(true);
            }}
            linkClickedRequired={true}
            textSize={CheckLabelTextSize.Large}
            errorText="リンクをクリックして、「海外不動産事業投資案件の契約締結前交付書面」の内容を確認してください"
          />
        </div>

        <div className="overseasRealEstateContractConfirm_wrapper">
          <Button
            label="契約締結を申込む"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            disable={!(checkedContractAgreementDocument && checkedAssignmentAgreementDocument)}
            onClick={onNext}
          />
          <Button label="HOMEに戻る" buttonFill={ButtonFill.link} buttonSize={ButtonSize.small} onClick={onBack} />
        </div>
      </div>
    </LoadingContainer>
  );
};
export const OverseasRealEstateContractConfirmBody = ({ contractInfo }: { contractInfo: ContractDetailInfo }) => {
  return (
    <>
      <ResultHeader label="案件名称" />
      <ResultBody label={contractInfo.SymbolName} />
      <ResultHeader label="申込金額" />
      <ResultBody label={formatPrice(contractInfo.ApplicationAmount) + '円'} />
      <ResultHeader label="支払日" />
      <ResultBody label={formatDate(new Date(contractInfo.PaymentDate), DateFormatType.Japanese_yyyyMd)} />
      <ResultHeader label="経過利息" />
      <ResultBody label={formatPrice(contractInfo.AccruedInterest) + '円'} />
      <ResultHeader label="譲渡代金総額" />
      <ResultBody label={formatPrice(contractInfo.TotalTransferFee) + '円'} />
    </>
  );
};
